<template>
  <v-dialog :value="filterForm.modalType === 'user'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển người phụ trách
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển người phụ trách"
              >
                <common-select-user
                  v-model="userId"
                  :items="users"
                  color="primary"
                  item-text="fullName"
                  item-value="id"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu Lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');
import TokenService from '../../../helpers/token';
export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
    users: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      userId: '',
    };
  },
  created() {
    const dataUser = TokenService.getUser() || {};
    this.userId = _.get(dataUser, 'id', '');
  },
  methods: {
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
      this.userId = '';
    },
    async saveChange() {
      let changeContactList = this.contacts.filter(
        contact => contact.checkbox
      );
      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng !!!'
        });
      }
      changeContactList = changeContactList.filter(contact => _.get(contact, 'user.id', '') != this.userId)
      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text:
            'Người phụ trách đang không thay đổi !!!'
        });
      }
      const dataUpdate = changeContactList.map(contact => ({
        contactId: contact.id,
        userId: this.userId
      }));
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactUser(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.$swal({
        title: 'Chuyển người phụ trách thành công !!!',
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
      });
    }
  }
};
</script>
